var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#8C99C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5649 8.4178C15.6974 8.28534 15.8546 8.18027 16.0277 8.10858C16.2007 8.0369 16.3862 8 16.5735 8C16.7609 8 16.9464 8.0369 17.1194 8.10858C17.2925 8.18027 17.4497 8.28534 17.5822 8.4178C17.7147 8.55026 17.8197 8.70751 17.8914 8.88057C17.9631 9.05364 18 9.23913 18 9.42645C18 9.61377 17.9631 9.79926 17.8914 9.97233C17.8197 10.1454 17.7147 10.3026 17.5822 10.4351L10.7738 17.2435L8 18L8.75649 15.2262L15.5649 8.4178Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.080fa0a15e18042d01c7e7118558350b.svg";
export { ForwardRef as ReactComponent };